module.exports = __webpack_public_path__ + "media/images/marketing/app_video_thumbnail1-b6d3e2e79b60eb665ca5ef6a286581c6bf8d0eb9a2d91917010ea8f8a69b6dc3.jpg";